import React, { useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Linking } from 'react-native';
import PlatformIcon from '../common/PlatformIcon';
import MetaRow from '../travel/MetaRow';
import BookingPlatformsRow from './shared/BookingPlatformsRow';
import { isWebsiteLabel } from '../travel/placeholder-config';

interface CardDetailContentProps {
  title: string;
  address?: string;
  description?: string;
  meta?: Array<{ label: string; value: string }>;
  tags?: string[];
  cardId?: string;
  cardType?: string;
  supabaseClient?: any;
  editMode?: boolean;
}

const CardDetailContent: React.FC<CardDetailContentProps> = ({
  title,
  address,
  description,
  meta = [],
  tags = [],
  cardId,
  cardType,
  supabaseClient,
  editMode = false,
}) => {
  const [activeTab, setActiveTab] = useState<'details' | 'description' | 'booking'>('details');
  
  // Debug: log that component is rendering
  React.useEffect(() => {
    console.log('[CardDetailContent] Rendering with props:', {
      title,
      address,
      description,
      metaLength: meta.length,
      cardId,
      cardType,
    });
  }, [title, address, description, meta.length, cardId, cardType]);

  // Simple test render first
  return (
    <View style={{ backgroundColor: '#f0f0f0', padding: 20, margin: 10 }}>
      <Text style={{ fontSize: 18, fontWeight: 'bold', color: '#333' }}>
        CardDetailContent 测试组件
      </Text>
      <Text style={{ color: '#666', marginTop: 5 }}>
        标题: {title}
      </Text>
      <Text style={{ color: '#666' }}>
        地址: {address || '无'}
      </Text>
      <Text style={{ color: '#666' }}>
        Meta 项目数: {meta.length}
      </Text>
    </View>
  );


};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  headerSection: {
    marginTop: 6,
  },
  title: {
    fontSize: 28,
    fontWeight: '800',
    color: '#111827',
  },
  divider: {
    height: 2,
    backgroundColor: '#0B61D6',
    opacity: 0.16,
    marginTop: 8,
    marginBottom: 12,
  },
  addressRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
  },
  addressText: {
    flex: 1,
    marginLeft: 8,
    color: '#6B7280',
    fontSize: 15,
  },
  navigationBtn: {
    paddingHorizontal: 6,
    paddingVertical: 4,
    marginLeft: 6,
  },
  tabsSection: {
    marginTop: 16,
  },
  tabsRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  tabBtn: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    marginRight: 8,
  },
  tabBtnActive: {
    borderBottomWidth: 2,
    borderBottomColor: '#0B61D6',
  },
  tabText: {
    fontSize: 14,
    color: '#6B7280',
    fontWeight: '500',
  },
  tabTextActive: {
    color: '#0B61D6',
    fontWeight: '600',
  },
  tabDivider: {
    height: 1,
    backgroundColor: '#E5E7EB',
  },
  tabContent: {
    paddingVertical: 16,
  },
  emptyText: {
    color: '#9CA3AF',
    fontSize: 14,
  },
  descriptionText: {
    color: '#374151',
    fontSize: 15,
    lineHeight: 22,
  },
});

export default CardDetailContent;